import React from 'react';
var ScaleContext = React.createContext({});
export default ScaleContext;
